import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context';
import api, { clearSession, setSession } from '../api/client';

// Puslapis, į kurį backend'as nukreipia po socialinio (OAuth) prisijungimo.
// URL fragmente ateina #token=... arba #error=...
export default function OAuthDonePage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('token');
    const err = params.get('error');
    window.history.replaceState(null, '', window.location.pathname);
    if (err || !token) {
      setError(err || 'Prisijungimas nepavyko');
      return;
    }
    setSession({ token, csrf: null });
    api.get('/auth/me')
      .then(r => {
        login({ ...r.data, token });
        navigate('/', { replace: true });
      })
      .catch(() => {
        clearSession();
        setError('Nepavyko gauti paskyros duomenų');
      });
  }, [login, navigate]);

  return (
    <div style={{ textAlign: 'center', padding: 100 }}>
      {error ? (
        <>
          <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
          <div style={{ fontFamily: 'Cinzel,serif', fontSize: 18, color: '#ff8080', marginBottom: 16 }}>{error}</div>
          <button className="btn btn-secondary" onClick={() => navigate('/')}>← Į pradžią</button>
        </>
      ) : (
        <>
          <div style={{ fontSize: 44, marginBottom: 12 }}>⏳</div>
          <div style={{ fontFamily: 'Cinzel,serif', fontSize: 16, color: 'var(--text3)' }}>Jungiama...</div>
        </>
      )}
    </div>
  );
}
